import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CarsPermissionPipesModule} from 'app/permissions/pipes/cars-permission-pipes.module';
import {ClauseLinkIconComponent} from './clause-link-icon.component';

@NgModule({
  imports: [CommonModule, MatTooltipModule, MatIconModule, CarsPermissionPipesModule],
  declarations: [ClauseLinkIconComponent],
  exports: [ClauseLinkIconComponent],
})
export class ClauseLinkIconModule {}
